// src/components/LoadingSpinner.jsx
import React from "react";

const LoadingSpinner = () => {
  return (
    <div style={styles.loaderContainer}>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="100px"
        height="100px"
        viewBox="0 0 100 100"
        enableBackground="new 0 0 100 100"
        xmlSpace="preserve"
      >
        <g>
          {/* Círculo exterior */}
          <circle
            fill="none"
            stroke="#3498db"
            strokeWidth="4"
            strokeMiterlimit="10"
            cx="50"
            cy="50"
            r="45"
            strokeDasharray="283"
            strokeDashoffset="0"
          >
            <animateTransform
              attributeName="transform"
              attributeType="XML"
              type="rotate"
              dur="2s"
              from="0 50 50"
              to="360 50 50"
              repeatCount="indefinite"
            />
          </circle>

          {/* Ícono de ticket */}
          <path
            fill="#3498db"
            d="M40,30 L60,30 L70,40 L70,70 L30,70 L30,40 L40,30 Z 
     M50,60 L50,50 
     M40,40 L60,40
     M45,50 L55,50"
          >
            <animateTransform
              attributeName="transform"
              attributeType="XML"
              type="rotate"
              dur="2s"
              from="0 50 50"
              to="-360 50 50"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </svg>
      <p style={styles.loadingText}>Cargando...</p>
    </div>
  );
};

const styles = {
  loaderContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f5f5f5", // Fondo suave para resaltar el spinner
  },
  loadingText: {
    marginTop: "20px",
    fontSize: "1.2rem",
    color: "#3498db",
    fontWeight: "bold",
  },
};

export default LoadingSpinner;
